export default __webpack_public_path__ + "static/media/barrils.962e9eeb.png";